"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_use_1 = require("react-use");
exports.useSlingshot = (ms, onValue, offValue) => {
    const [on, toggle] = react_use_1.useToggle(false);
    const [isReady, toggleReady] = react_use_1.useToggle(false);
    const [, , reset] = react_use_1.useTimeoutFn(() => {
        if (isReady) {
            toggle();
        }
        else {
            toggleReady(true);
        }
    }, ms);
    return [
        on ? onValue : offValue,
        newVal => {
            toggle(newVal);
            reset();
        },
    ];
};
//# sourceMappingURL=hooks.js.map